import { emit } from "@/neon/events";

const isFirstSectionOnHomepage = node => {
  const body = document.body;
  if (!body.classList.contains("template-index")) return;

  const firstSection = body.querySelector(".section-dynamic");
  const sectionParent = node.parentNode;

  if (firstSection === sectionParent) emit("section:first-full-height");

  return firstSection === sectionParent;
};

export default isFirstSectionOnHomepage;
